var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGMeetingsInner.jinja');
require('./MyADGMeetingsInner.less');

module.exports = Base.extend({

    template: template,

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGMeetings/MyADGMeetingsInner.js
// module id = 222
// module chunks = 0